import Divider from "@mui/material/Divider";
import Drawer, { drawerClasses } from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import { useColorScheme } from "@mui/material/styles";
import { Suspense, lazy, memo } from "react";

import { colors } from "@/theme";
import { cloudPatternUrl } from "@/theme/customizations";

import MenuContent from "./MenuContent";
import SidebarLogo from "./SidebarLogo";

// The sportsbook tree (and its sport hooks) only on the sport pages, where that chunk is loading anyway.
const SportSidebarContent = lazy(() => import("@/layout/Sport/SidebarContent"));

interface SideMenuMobileProps {
  open: boolean | undefined;
  toggleDrawer: () => void;
  isSport?: boolean;
}

const SideMenuMobile = memo(({ open, toggleDrawer, isSport }: SideMenuMobileProps) => {
  const { mode } = useColorScheme();

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={toggleDrawer}
      sx={(theme) => ({
        width: "100%",
        zIndex: theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          width: "100%",
          backgroundImage: cloudPatternUrl(colors.prime),
          backdropFilter: "blur(1px)",
        },
      })}
      className={mode}
    >
      <Stack>
        <SidebarLogo toggleDrawer={toggleDrawer} />
      </Stack>
      <Stack sx={{ height: "100%" }}>
        <Stack sx={{ flexGrow: 1 }}>
          {isSport ? (
            <Suspense fallback={null}>
              <SportSidebarContent toggleDrawer={toggleDrawer} />
            </Suspense>
          ) : (
            <MenuContent toggleDrawer={toggleDrawer} />
          )}
          <Divider />
        </Stack>
      </Stack>
    </Drawer>
  );
});
SideMenuMobile.displayName = "SideMenuMobile";

export default SideMenuMobile;
